export const COUNTRIES = ['Germany', 'Brazil', 'United States'];

export const COUNTRY_OPTIONS = COUNTRIES.map((country) => ({ label: country, value: country }));
